import { DownloadOfmStatus } from "./ofm.download.status";

export const colorByDownloadStatus: Record<DownloadOfmStatus, string> = {
  [DownloadOfmStatus.READY]: "bg-emerald-500",
  [DownloadOfmStatus.PREPARING]: "bg-amber-500 animate-pulse",
  [DownloadOfmStatus.ERROR]: "bg-rose-500",
  [DownloadOfmStatus.EXPIRED]: "bg-zinc-400",
};
